<template>
  <div class="conditions">
    <h2 class="conditions-gral">
      CONDICIONES GENERALES
    </h2>
    <div class="conditions-terms">
      {{ text }}
    </div>
    <div
      class="text-center"
      v-if="text"
    >
      <checkbox
        class="conditions-check"
        v-model="agree"
      >
        Estoy de acuerdo con las condiciones generales.
      </checkbox>
    </div>
    <div class="txt-right py-2 border-top my-3">
      <btn
        color="orange"
        size="xs"
        class="xs-4"
        @click.prevent="next"
        :disabled="!agree"
      >
        FINALIZAR RESERVA
      </btn>
      <btn
        color="outline"
        size="xs"
        class="xs-4"
        @click="$emit('close')"
      >
        CANCELAR
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import Checkbox from '@/components/Checkbox'
import axios from 'axios'
import swal from 'sweetalert2'
import { API_ENDPOINT_BASE, ROOT } from '@/constans'
import { LOADING } from '@/store/mutations'
import { stringify } from 'qs'

export default {
  components: {
    Checkbox,
    Btn
  },

  data () {
    return {
      text: null,
      agree: false
    }
  },
  methods: {
    next () {
      if (this.agree) {
        this.$store
          .dispatch('modify/CONFIRM')
          .then(e => {
            this.$emit('goto', 'success')
          })
          .catch(html => {
            swal({ html, type: 'error' })
          })
      } else {
        swal({
          html:
							'Debe leer y marcar que esta de acuerdo con las condiciones generales antes de continuar.',
          type: 'error'
        })
      }
    }
  },

  beforeCreate () {
    this.$store.commit(LOADING, true, ROOT)
    axios
      .post(API_ENDPOINT_BASE + '/modify/conditions/' + this.$store.state.modify.id)
      .catch(error => {
        swal({ html: error.response.data.msg, type: 'error' }).then(e => console.log(e))
      })
      .then(({ data }) => (this.text = data.conditions))
      .finally(() => this.$store.commit(LOADING, false, ROOT))
  }
}
</script>
